// extracted by mini-css-extract-plugin
module.exports = {"memberWrapper":"page_memberWrapper__LakiO","memberContent":"page_memberContent__7n6cn","teamMemberImage":"page_teamMemberImage__GjbnC"};